import React from 'react';
import { UserProfileProvider } from './contexts/UserProfileContext';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return (
    <UserProfileProvider>
      {element}
    </UserProfileProvider>
  );
};
